
<template>
    <div>  
      <label class="form-label" for="here-map"><span>Unesite naziv lokacije ili odaberite na karti</span></label><br>  
      <div class="autocomplete-wrapper">
        <input
          :class="['form-autocomplete', 'input-adress-location']"
            label="Adresa"
            id="lokacija"
          type="text"
          v-model="lokacijaInput"
          @keyup.enter="getCoordinates"
        />
        <div class="autocomplete-confirm" @click="getCoordinates">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="10"
            viewBox="0 0 21 10"
          >
            <g>
              <g>
                <path
                  fill="#3326ae"
                  d="M20.94 4.303L16.26.026a.39.39 0 0 0-.427-.06.355.355 0 0 0-.232.354v2.737H.39a.379.379 0 0 0-.28.11.381.381 0 0 0-.11.28v2.347a.38.38 0 0 0 .11.28.38.38 0 0 0 .28.11h15.212v2.738c0 .163.077.281.231.354a.38.38 0 0 0 .427-.073l4.68-4.326a.4.4 0 0 0 0-.574z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
        <!-- <label class="form-label" for="here-map"><span>Odaberite lokaciju na karti</span></label><br> -->
        <div id="map" :class="['map',invalid ? 'invalid':'']" name="here-map"></div>
    </div>
</template>

<script>
import formInput from "@/components/formElements/formInput.vue";
import $ from 'jquery';
export default {
  props:['invalid'],
  components:{formInput},
  data() {
    return {
        chosen_location: {lat:-1, lng:-1},
        lokacijaInput:"",
        user_location:{lat:0,lng:0},
        map:null,
    };
  },
  async mounted() {
    // Initialize the platform object:
    this.initializeHereMap();
    this.setUpClickListener(this.map);
    
  },
  methods: {
    getCoordinates(){
      let address = this.lokacijaInput;
      var service = this.platform.getSearchService();
      //Pošalji unesenu adresu
      service.discover({
        q: address,
        at: this.user_location.lat+','+this.user_location.lng,
        limit: '1'
      }, (resp) => {
        //dohvati rezultat s najboljim score-om
        if (resp.items.length == 0) {
          alert("Nije moguće pronaći unesenu lokaciju")
        }
        else{
          var most_relevant = resp.items[0];
          //Input popuni s nazivom lokacije
          this.lokacijaInput = most_relevant.address.district != most_relevant.address.city
            && most_relevant.address.district != undefined && most_relevant.address.city != undefined
            ? most_relevant.address.district+', '+ most_relevant.address.label 
            : most_relevant.address.label;
          //Dodaj marker na kartu
          this.map.removeObjects(this.map.getObjects())
          const marker = new H.map.Marker(most_relevant.position);
          this.map.addObject(marker)
          this.chosen_location = most_relevant.position
          this.map.setCenter(most_relevant.position);
          this.map.setZoom(16);
        }
      });
    },
    setMarkerObject(coords){
          this.map.removeObjects(this.map.getObjects())
          const marker = new H.map.Marker(coords);
          this.map.addObject(marker)
          this.chosen_location = coords
          this.map.setCenter(coords);
          this.map.setZoom(16);
    },
    setUpClickListener(map) {
        let _this = this;
        // Attach an event listener to map display
        map.addEventListener('tap', function (evt) {
            map.removeObjects(map.getObjects())
            let coords = map.screenToGeo(evt.currentPointer.viewportX,
                    evt.currentPointer.viewportY); 
            const marker = new H.map.Marker(coords);
            map.addObject(marker);
            _this.chosen_location = coords
            var service = _this.platform.getSearchService();
            //Pronađi naziv lokacije označene na karti
            service.reverseGeocode({
              at: coords.lat+','+coords.lng
            }, (resp) => {
              var location = resp.items[0];
              //Naziv lokacije unesi u input
              _this.lokacijaInput = location.address.district != location.address.city 
                && location.address.district != undefined && location.address.city != undefined
                ? location.address.district+', '+ location.address.label 
                : location.address.label;
          });
        });

    },
    initializeHereMap() {
        //map rendering
        //kasnije sakriti apiKey
        this.platform = new H.service.Platform({
            'apiKey': 'YbyZXsNuDB3mKg-dk61TDiXX2QpbmPrvRP1hnM2SH5U',
        });
        var defaultLayers = this.platform.createDefaultLayers();

        //map init
        this.map = new H.Map(document.getElementById('map'),
            defaultLayers.vector.normal.map,{
            center: {lat:46.315, lng: 16.325},
            zoom: 11,
            pixelRatio: window.devicePixelRatio || 1
        });
        // add a resize listener to make sure that the map occupies the whole container
        window.addEventListener('resize', () => this.map.getViewPort().resize());

        // MapEvents enables the event system
        // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
        var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
        navigator.geolocation.getCurrentPosition((position)=>{
          this.user_location = {lat:position.coords.latitude, lng:position.coords.longitude}
          this.map.setCenter({lat:position.coords.latitude, lng:position.coords.longitude})
        });
    }
  },
};
</script>
